import { createReducer } from 'redux-act';
import actions from '../actions/onboardingActions';

const initialState = {
  // personal details
  addPersonalDetailsPending: false,
  addPersonalDetailsRes: null,
  addPersonalDetailsError: null,

  getAllPersonalDetailsPending: false,
  getAllPersonalDetailsRes: null,
  getAllPersonalDetailsError: null,

  updatePersonalDetailsPending: false,
  updatePersonalDetailsRes: null,
  updatePersonalDetailsError: null,

  // family details
  addFamilyDetailsPending: false,
  addFamilyDetailsRes: null,
  addFamilyDetailsError: null,

  getAllFamilyDetailsPending: false,
  getAllFamilyDetailsRes: null,
  getAllFamilyDetailsError: null,

  updateFamilyDetailsPending: false,
  updateFamilyDetailsRes: null,
  updateFamilyDetailsError: null,

  // Education details
  addEducationDetailsPending: false,
  addEducationDetailsRes: null,
  addEducationDetailsError: null,

  getEducationDetailsPending: false,
  getEducationDetailsRes: null,
  getEducationDetailsError: null,

  updateEducationDetailsPending: false,
  updateEducationDetailsRes: null,
  updateEducationDetailsError: null,

  // bank details
  addBankDetailsPending: false,
  addBankDetailsRes: null,
  addBankDetailsError: null,

  getAllBankDetailsPending: false,
  getAllBankDetailsRes: null,
  getAllBankDetailsError: null,

  updateBankDetailsPending: false,
  updateBankDetailsRes: null,
  updateBankDetailsError: null,

  // Work Experience details
  addWorkExperienceDetailsPending: false,
  addWorkExperienceDetailsRes: null,
  addWorkExperienceDetailsError: null,

  getWorkExperienceDetailsPending: false,
  getWorkExperienceDetailsRes: null,
  getWorkExperienceDetailsError: null,

  updateWorkExperienceDetailsPending: false,
  updateWorkExperienceDetailsRes: null,
  updateWorkExperienceDetailsError: null,

  // social details
  addSocialDetailsPending: false,
  addSocialDetailsRes: null,
  addSocialDetailsError: null,

  getSocialDetailsPending: false,
  getSocialDetailsRes: null,
  getSocialDetailsError: null,

  updateSocialDetailsPending: false,
  updateSocialDetailsRes: null,
  updateSocialDetailsError: null,

  // reference details
  addReferenceDetailsPending: false,
  addReferenceDetailsRes: null,
  addReferenceDetailsError: null,

  getReferenceDetailsPending: false,
  getReferenceDetailsRes: null,
  getReferenceDetailsError: null,

  updateReferenceDetailsPending: false,
  updateReferenceDetailsRes: null,
  updateReferenceDetailsError: null,

  // upload document details
  addDocumentDetailsPending: false,
  addDocumentDetailsRes: null,
  addDocumentDetailsError: null,

  getDocumentDetailsPending: false,
  getDocumentDetailsRes: null,
  getDocumentDetailsError: null,

  updateDocumentDetailsPending: false,
  updateDocumentDetailsRes: null,
  updateDocumentDetailsError: null,

  getAllOnboardingDetailsPending: false,
  getAllOnboardingDetailsRes: null,
  getAllOnboardingDetailsError: null,

  getAllEmpDocsPending: false,
  getAllEmpDocsRes: null,
  getAllEmpDocsError: null,

};

//***************PERSONAL DETAILS***************

// add personal details
const handleAddPersonalDetailsRequest = state => {
  return {
    ...state,
    ...{
      addPersonalDetailsPending: true,
      addPersonalDetailsRes: null,
      addPersonalDetailsError: null,
    },
  };
};
const handleAddPersonalDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addPersonalDetailsPending: false,
      addPersonalDetailsRes: payload,
      addPersonalDetailsError: null,
    },
  };
};
const handleAddPersonalDetailsError = (state, payload) => ({
  ...state,
  ...{
    addPersonalDetailsPending: false,
    addPersonalDetailsRes: null,
    addPersonalDetailsError: payload,
  },
});


// get personal details 
const handleGetAllPersonalDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllPersonalDetailsPending: true,
      getAllPersonalDetailsRes: null,
      getAllPersonalDetailsError: null,
    },
  };
};
const handleGetAllPersonalDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllPersonalDetailsPending: false,
      getAllPersonalDetailsRes: payload,
      getAllPersonalDetailsError: null,
    },
  };
};
const handleGetAllPersonalDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getAllPersonalDetailsPending: false,
    getAllPersonalDetailsRes: null,
    getAllPersonalDetailsError: payload,
  },
});

// update personal details 
const handleUpdatePersonalDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      updatePersonalDetailsPending: true,
      updatePersonalDetailsRes: null,
      updatePersonalDetailsError: null,
    },
  };
};
const handleUpdatePersonalDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updatePersonalDetailsPending: false,
      updatePersonalDetailsRes: payload,
      updatePersonalDetailsError: null,
    },
  };
};
const handleUpdatePersonalDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    updatePersonalDetailsPending: false,
    updatePersonalDetailsRes: null,
    updatePersonalDetailsError: payload,
  },
});

// clear existing personal data
const clearPersonalDetails = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_PERSONAL_DETAILS':
      return {
        ...state,
        ...{
          addPersonalDetailsPending: false,
          addPersonalDetailsRes: null,
          addPersonalDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_PERSONAL_DETAILS':
      return {
        ...state,
        ...{
          updatePersonalDetailsPending: false,
          updatePersonalDetailsRes: null,
          updatePersonalDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_PERSONAL_DETAILS':
      return {
        ...state,
        ...{
          deletePersonalDetailsPending: false,
          deletePersonalDetailsRes: null,
          deletePersonalDetailsError: null,
        },
      };
    default:
      return state;
  }
};

//***************FAMILY DETAILS***************
// add family details
const handleAddFamilyDetailsRequest = state => {
  return {
    ...state,
    ...{
      addFamilyDetailsPending: true,
      addFamilyDetailsRes: null,
      addFamilyDetailsError: null,
    },
  };
};
const handleAddFamilyDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addFamilyDetailsPending: false,
      addFamilyDetailsRes: payload,
      addFamilyDetailsError: null,
    },
  };
};
const handleAddFamilyDetailsError = (state, payload) => ({
  ...state,
  ...{
    addFamilyDetailsPending: false,
    addFamilyDetailsRes: null,
    addFamilyDetailsError: payload,
  },
});


// get family details 
const handleGetAllFamilyDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllFamilyDetailsPending: true,
      getAllFamilyDetailsRes: null,
      getAllFamilyDetailsError: null,
    },
  };
};
const handleGetAllFamilyDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllFamilyDetailsPending: false,
      getAllFamilyDetailsRes: payload,
      getAllFamilyDetailsError: null,
    },
  };
};
const handleGetAllFamilyDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getAllFamilyDetailsPending: false,
    getAllFamilyDetailsRes: null,
    getAllFamilyDetailsError: payload,
  },
});

// update family details 
const handleUpdateFamilyDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateFamilyDetailsPending: true,
      updateFamilyDetailsRes: null,
      updateFamilyDetailsError: null,
    },
  };
};
const handleUpdateFamilyDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateFamilyDetailsPending: false,
      updateFamilyDetailsRes: payload,
      updateFamilyDetailsError: null,
    },
  };
};
const handleUpdateFamilyDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    updateFamilyDetailsPending: false,
    updateFamilyDetailsRes: null,
    updateFamilyDetailsError: payload,
  },
});

// clear existing family data
const clearFamilyDetails = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_FAMILY_DETAILS':
      return {
        ...state,
        ...{
          addFamilyDetailsPending: false,
          addFamilyDetailsRes: null,
          addFamilyDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_FAMILY_DETAILS':
      return {
        ...state,
        ...{
          updateFamilyDetailsPending: false,
          updateFamilyDetailsRes: null,
          updateFamilyDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_FAMILY_DETAILS':
      return {
        ...state,
        ...{
          deleteFamilyDetailsPending: false,
          deleteFamilyDetailsRes: null,
          deleteFamilyDetailsError: null,
        },
      };
    default:
      return state;
  }
};

/*******************  Eduction Detail *************** */
// add Education details
const handleAddEducationDetailsRequest = state => {
  return {
    ...state,
    ...{
      addEducationDetailsPending: true,
      addEducationDetailsRes: null,
      addEducationDetailsError: null,
    },
  };
};
const handleAddEducationDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addEducationDetailsPending: false,
      addEducationDetailsRes: payload,
      addEducationDetailsError: null,
    },
  };
};
const handleAddEducationDetailsError = (state, payload) => ({
  ...state,
  ...{
    addEducationDetailsPending: false,
    addEducationDetailsRes: null,
    addEducationDetailsError: payload,
  },
});

// get Education details 
const handleGetEducationDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getEducationDetailsPending: true,
      getEducationDetailsRes: null,
      getEducationDetailsError: null,
    },
  };
};
const handleGetEducationDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEducationDetailsPending: false,
      getEducationDetailsRes: payload,
      getEducationDetailsError: null,
    },
  };
};
const handleGetEducationDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getEducationDetailsPending: false,
    getEducationDetailsRes: null,
    getEducationDetailsError: payload,
  },
});

// update Education details 
const handleUpdateEducationDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateEducationDetailsPending: true,
      updateEducationDetailsRes: null,
      updateEducationDetailsError: null,
    },
  };
};
const handleUpdateEducationDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateEducationDetailsPending: false,
      updateEducationDetailsRes: payload,
      updateEducationDetailsError: null,
    },
  };
};
const handleUpdateEducationDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    updateEducationDetailsPending: false,
    updateEducationDetailsRes: null,
    updateEducationDetailsError: payload,
  },
});

const clearEducationDetails = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_EDUCATION_DETAILS':
      return {
        ...state,
        ...{
          addEducationDetailsPending: false,
          addEducationDetailsRes: null,
          addEducationDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_EDUCATION_DETAILS':
      return {
        ...state,
        ...{
          updateEducationDetailsPending: false,
          updateEducationDetailsRes: null,
          updateEducationDetailsError: null,
        },
      };

    default:
      return state;
  }
};

//***************BANK DETAILS***************
// add bank details
const handleAddBankDetailsRequest = state => {
  return {
    ...state,
    ...{
      addBankDetailsPending: true,
      addBankDetailsRes: null,
      addBankDetailsError: null,
    },
  };
};
const handleAddBankDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addBankDetailsPending: false,
      addBankDetailsRes: payload,
      addBankDetailsError: null,
    },
  };
};
const handleAddBankDetailsError = (state, payload) => ({
  ...state,
  ...{
    addBankDetailsPending: false,
    addBankDetailsRes: null,
    addBankDetailsError: payload,
  },
});

// get bank details 
const handleGetAllBankDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllBankDetailsPending: true,
      getAllBankDetailsRes: null,
      getAllBankDetailsError: null,
    },
  };
};
const handleGetAllBankDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllBankDetailsPending: false,
      getAllBankDetailsRes: payload,
      getAllBankDetailsError: null,
    },
  };
};
const handleGetAllBankDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getAllBankDetailsPending: false,
    getAllBankDetailsRes: null,
    getAllBankDetailsError: payload,
  },
});

// update bank details 
const handleUpdateBankDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateBankDetailsPending: true,
      updateBankDetailsRes: null,
      updateBankDetailsError: null,
    },
  };
};
const handleUpdateBankDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateBankDetailsPending: false,
      updateBankDetailsRes: payload,
      updateBankDetailsError: null,
    },
  };
};
const handleUpdateBankDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    updateBankDetailsPending: false,
    updateBankDetailsRes: null,
    updateBankDetailsError: payload,
  },
});

// clear existing bank data
const clearBankDetails = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_BANK_DETAILS':
      return {
        ...state,
        ...{
          addBankDetailsPending: false,
          addBankDetailsRes: null,
          addBankDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_BANK_DETAILS':
      return {
        ...state,
        ...{
          updateBankDetailsPending: false,
          updateBankDetailsRes: null,
          updateBankDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_BANK_DETAILS':
      return {
        ...state,
        ...{
          deleteBankDetailsPending: false,
          deleteBankDetailsRes: null,
          deleteBankDetailsError: null,
        },
      };
    default:
      return state;
  }
};

//***************SOCIAL DETAILS***************
// add social details
const handleAddSocialDetailsRequest = state => {
  return {
    ...state,
    ...{
      addSocialDetailsPending: true,
      addSocialDetailsRes: null,
      addSocialDetailsError: null,
    },
  };
};
const handleAddSocialDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addSocialDetailsPending: false,
      addSocialDetailsRes: payload,
      addSocialDetailsError: null,
    },
  };
};
const handleAddSocialDetailsError = (state, payload) => ({
  ...state,
  ...{
    addSocialDetailsPending: false,
    addSocialDetailsRes: null,
    addSocialDetailsError: payload,
  },
});

// get social details 
const handleGetAllSocialDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllSocialDetailsPending: true,
      getAllSocialDetailsRes: null,
      getAllSocialDetailsError: null,
    },
  };
};
const handleGetAllSocialDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllSocialDetailsPending: false,
      getAllSocialDetailsRes: payload,
      getAllSocialDetailsError: null,
    },
  };
};
const handleGetAllSocialDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getAllSocialDetailsPending: false,
    getAllSocialDetailsRes: null,
    getAllSocialDetailsError: payload,
  },
});

// update social details 
const handleUpdateSocialDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateSocialDetailsPending: true,
      updateSocialDetailsRes: null,
      updateSocialDetailsError: null,
    },
  };
};
const handleUpdateSocialDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateSocialDetailsPending: false,
      updateSocialDetailsRes: payload,
      updateSocialDetailsError: null,
    },
  };
};
const handleUpdateSocialDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    updateSocialDetailsPending: false,
    updateSocialDetailsRes: null,
    updateSocialDetailsError: payload,
  },
});

// clear existing social data
const clearSocialDetails = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_SOCIAL_DETAILS':
      return {
        ...state,
        ...{
          addSocialDetailsPending: false,
          addSocialDetailsRes: null,
          addSocialDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_SOCIAL_DETAILS':
      return {
        ...state,
        ...{
          updateSocialDetailsPending: false,
          updateSocialDetailsRes: null,
          updateSocialDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_SOCIAL_DETAILS':
      return {
        ...state,
        ...{
          deleteSocialDetailsPending: false,
          deleteSocialDetailsRes: null,
          deleteSocialDetailsError: null,
        },
      };
    default:
      return state;
  }
};




//***************WORK EXPERIENCE DETAILS***************
// add Work Experience details
const handleAddWorkExperienceDetailsRequest = state => {
  return {
    ...state,
    ...{
      addWorkExperienceDetailsPending: true,
      addWorkExperienceDetailsRes: null,
      addWorkExperienceDetailsError: null,
    },
  };
};
const handleAddWorkExperienceDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addWorkExperienceDetailsPending: false,
      addWorkExperienceDetailsRes: payload,
      addWorkExperienceDetailsError: null,
    },
  };
};
const handleAddWorkExperienceDetailsError = (state, payload) => ({
  ...state,
  ...{
    addWorkExperienceDetailsPending: false,
    addWorkExperienceDetailsRes: null,
    addWorkExperienceDetailsError: payload,
  },
});

// get Work Experience details 
const handleGetWorkExperienceDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getWorkExperienceDetailsPending: true,
      getWorkExperienceDetailsRes: null,
      getWorkExperienceDetailsError: null,
    },
  };
};
const handleGetWorkExperienceDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getWorkExperienceDetailsPending: false,
      getWorkExperienceDetailsRes: payload,
      getWorkExperienceDetailsError: null,
    },
  };
};
const handleGetWorkExperienceDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getWorkExperienceDetailsPending: false,
    getWorkExperienceDetailsRes: null,
    getWorkExperienceDetailsError: payload,
  },
});

// update Work Experience details 
const handleUpdateWorkExperienceDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateWorkExperienceDetailsPending: true,
      updateWorkExperienceDetailsRes: null,
      updateWorkExperienceDetailsError: null,
    },
  };
};
const handleUpdateWorkExperienceDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateWorkExperienceDetailsPending: false,
      updateWorkExperienceDetailsRes: payload,
      updateWorkExperienceDetailsError: null,
    },
  };
};
const handleUpdateWorkExperienceDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    updateWorkExperienceDetailsPending: false,
    updateWorkExperienceDetailsRes: null,
    updateWorkExperienceDetailsError: payload,
  },
});

// clear existing work experience data
const clearWorkExperienceDetails = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_WORK_EXPERIENCE_DETAILS':
      return {
        ...state,
        ...{
          addWorkExperienceDetailsPending: false,
          addWorkExperienceDetailsRes: null,
          addWorkExperienceDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_WORK_EXPERIENCE_DETAILS':
      return {
        ...state,
        ...{
          updateWorkExperienceDetailsPending: false,
          updateWorkExperienceDetailsRes: null,
          updateWorkExperienceDetailsError: null,
        },
      };

    default:
      return state;
  }
};

//***************REFERENCE DETAILS***************
// add reference details
const handleAddReferenceDetailsRequest = state => {
  return {
    ...state,
    ...{
      addReferenceDetailsPending: true,
      addReferenceDetailsRes: null,
      addReferenceDetailsError: null,
    },
  };
};
const handleAddReferenceDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addReferenceDetailsPending: false,
      addReferenceDetailsRes: payload,
      addReferenceDetailsError: null,
    },
  };
};
const handleAddReferenceDetailsError = (state, payload) => ({
  ...state,
  ...{
    addReferenceDetailsPending: false,
    addReferenceDetailsRes: null,
    addReferenceDetailsError: payload,
  },
});

// get reference details 
const handleGetAllReferenceDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllReferenceDetailsPending: true,
      getAllReferenceDetailsRes: null,
      getAllReferenceDetailsError: null,
    },
  };
};
const handleGetAllReferenceDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllReferenceDetailsPending: false,
      getAllReferenceDetailsRes: payload,
      getAllReferenceDetailsError: null,
    },
  };
};
const handleGetAllReferenceDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getAllReferenceDetailsPending: false,
    getAllReferenceDetailsRes: null,
    getAllReferenceDetailsError: payload,
  },
});

// update reference details 
const handleUpdateReferenceDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateReferenceDetailsPending: true,
      updateReferenceDetailsRes: null,
      updateReferenceDetailsError: null,
    },
  };
};
const handleUpdateReferenceDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateReferenceDetailsPending: false,
      updateReferenceDetailsRes: payload,
      updateReferenceDetailsError: null,
    },
  };
};
const handleUpdateReferenceDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    updateReferenceDetailsPending: false,
    updateReferenceDetailsRes: null,
    updateReferenceDetailsError: payload,
  },
});

// clear existing reference data
const clearReferenceDetails = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_REFERENCE_DETAILS':
      return {
        ...state,
        ...{
          addReferenceDetailsPending: false,
          addReferenceDetailsRes: null,
          addReferenceDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_REFERENCE_DETAILS':
      return {
        ...state,
        ...{
          updateReferenceDetailsPending: false,
          updateReferenceDetailsRes: null,
          updateReferenceDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_REFERENCE_DETAILS':
      return {
        ...state,
        ...{
          deleteReferenceDetailsPending: false,
          deleteReferenceDetailsRes: null,
          deleteReferenceDetailsError: null,
        },
      };
    default:
      return state;
  }
};

//***************UPLOAD DOCUMENT DETAILS***************
// add document details
const handleAddDocumentDetailsRequest = state => {
  return {
    ...state,
    ...{
      addDocumentDetailsPending: true,
      addDocumentDetailsRes: null,
      addDocumentDetailsError: null,
    },
  };
};
const handleAddDocumentDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addDocumentDetailsPending: false,
      addDocumentDetailsRes: payload,
      addDocumentDetailsError: null,
    },
  };
};
const handleAddDocumentDetailsError = (state, payload) => ({
  ...state,
  ...{
    addDocumentDetailsPending: false,
    addDocumentDetailsRes: null,
    addDocumentDetailsError: payload,
  },
});

// get reference details 
const handleGetAllDocumentDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllDocumentDetailsPending: true,
      getAllDocumentDetailsRes: null,
      getAllDocumentDetailsError: null,
    },
  };
};
const handleGetAllDocumentDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllDocumentDetailsPending: false,
      getAllDocumentDetailsRes: payload,
      getAllDocumentDetailsError: null,
    },
  };
};
const handleGetAllDocumentDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getAllDocumentDetailsPending: false,
    getAllDocumentDetailsRes: null,
    getAllDocumentDetailsError: payload,
  },
});

// update reference details 
const handleUpdateDocumentDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateDocumentDetailsPending: true,
      updateDocumentDetailsRes: null,
      updateDocumentDetailsError: null,
    },
  };
};
const handleUpdateDocumentDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateDocumentDetailsPending: false,
      updateDocumentDetailsRes: payload,
      updateDocumentDetailsError: null,
    },
  };
};
const handleUpdateDocumentDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    updateDocumentDetailsPending: false,
    updateDocumentDetailsRes: null,
    updateDocumentDetailsError: payload,
  },
});

// clear existing document data
const clearDocumentDetails = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_DOCUMENT_DETAILS':
      return {
        ...state,
        ...{
          addDocumentDetailsPending: false,
          addDocumentDetailsRes: null,
          addDocumentDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_DOCUMENT_DETAILS':
      return {
        ...state,
        ...{
          updateDocumentDetailsPending: false,
          updateDocumentDetailsRes: null,
          updateDocumentDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_DOCUMENT_DETAILS':
      return {
        ...state,
        ...{
          deleteDocumentDetailsPending: false,
          deleteDocumentDetailsRes: null,
          deleteDocumentDetailsError: null,
        },
      };

    default:
      return state;
  }
};

const handleClearOnboardingStore = (state, payload) => {
  switch (payload) {
    
    default:
      return state;
  }
};

// get onbaording steps details 
const handleGetAllOnboardingDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllOnboardingDetailsPending: true,
      getAllOnboardingDetailsRes: null,
      getAllOnboardingDetailsError: null,
    },
  };
};
const handleGetAllOnboardingDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllOnboardingDetailsPending: false,
      getAllOnboardingDetailsRes: payload,
      getAllOnboardingDetailsError: null,
    },
  };
};
const handleGetAllOnboardingDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getAllOnboardingDetailsPending: false,
    getAllOnboardingDetailsRes: null,
    getAllOnboardingDetailsError: payload,
  },
});

// get employee docs details 
const handleGetAllEmpDocsRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllEmpDocsPending: true,
      getAllEmpDocsRes: null,
      getAllEmpDocsError: null,
    },
  };
};
const handleGetAllEmpDocsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllEmpDocsPending: false,
      getAllEmpDocsRes: payload,
      getAllEmpDocsError: null,
    },
  };
};
const handleGetAllEmpDocsError = (state1, payload) => ({
  ...state1,
  ...{
    getAllEmpDocsPending: false,
    getAllEmpDocsRes: null,
    getAllEmpDocsError: payload,
  },
});

export default createReducer(
  {
    // PERSONAL DETAILS
    [actions.addPersonalDetailsRequest]: handleAddPersonalDetailsRequest,
    [actions.addPersonalDetailsSuccess]: handleAddPersonalDetailsSuccess,
    [actions.addPersonalDetailsError]: handleAddPersonalDetailsError,

    [actions.getAllPersonalDetailsRequest]: handleGetAllPersonalDetailsRequest,
    [actions.getAllPersonalDetailsSuccess]: handleGetAllPersonalDetailsSuccess,
    [actions.getAllPersonalDetailsError]: handleGetAllPersonalDetailsError,

    [actions.updatePersonalDetailsRequest]: handleUpdatePersonalDetailsRequest,
    [actions.updatePersonalDetailsSuccess]: handleUpdatePersonalDetailsSuccess,
    [actions.updatePersonalDetailsError]: handleUpdatePersonalDetailsError,

    [actions.handleClearPersonalDetails]: clearPersonalDetails,

    // FAMILY DETAILS
    [actions.addFamilyDetailsRequest]: handleAddFamilyDetailsRequest,
    [actions.addFamilyDetailsSuccess]: handleAddFamilyDetailsSuccess,
    [actions.addFamilyDetailsError]: handleAddFamilyDetailsError,

    [actions.getAllFamilyDetailsRequest]: handleGetAllFamilyDetailsRequest,
    [actions.getAllFamilyDetailsSuccess]: handleGetAllFamilyDetailsSuccess,
    [actions.getAllFamilyDetailsError]: handleGetAllFamilyDetailsError,

    [actions.updateFamilyDetailsRequest]: handleUpdateFamilyDetailsRequest,
    [actions.updateFamilyDetailsSuccess]: handleUpdateFamilyDetailsSuccess,
    [actions.updateFamilyDetailsError]: handleUpdateFamilyDetailsError,

    [actions.handleClearFamilyDetails]: clearFamilyDetails,

    // EDUCATION DETAILS
    [actions.addEducationDetailsRequest]: handleAddEducationDetailsRequest,
    [actions.addEducationDetailsSuccess]: handleAddEducationDetailsSuccess,
    [actions.addEducationDetailsError]: handleAddEducationDetailsError,

    [actions.getEducationDetailsRequest]: handleGetEducationDetailsRequest,
    [actions.getEducationDetailsSuccess]: handleGetEducationDetailsSuccess,
    [actions.getEducationDetailsError]: handleGetEducationDetailsError,

    [actions.updateEducationDetailsRequest]: handleUpdateEducationDetailsRequest,
    [actions.updateEducationDetailsSuccess]: handleUpdateEducationDetailsSuccess,
    [actions.updateEducationDetailsError]: handleUpdateEducationDetailsError,

    [actions.handleClearEducationDetails]: clearEducationDetails,

    //BANK DETAILS
    [actions.addBankDetailsRequest]: handleAddBankDetailsRequest,
    [actions.addBankDetailsSuccess]: handleAddBankDetailsSuccess,
    [actions.addBankDetailsError]: handleAddBankDetailsError,

    [actions.getAllBankDetailsRequest]: handleGetAllBankDetailsRequest,
    [actions.getAllBankDetailsSuccess]: handleGetAllBankDetailsSuccess,
    [actions.getAllBankDetailsError]: handleGetAllBankDetailsError,

    [actions.updateBankDetailsRequest]: handleUpdateBankDetailsRequest,
    [actions.updateBankDetailsSuccess]: handleUpdateBankDetailsSuccess,
    [actions.updateBankDetailsError]: handleUpdateBankDetailsError,

    [actions.handleClearBankDetails]: clearBankDetails,

    //SOCIAL DETAILS
    [actions.addSocialDetailsRequest]: handleAddSocialDetailsRequest,
    [actions.addSocialDetailsSuccess]: handleAddSocialDetailsSuccess,
    [actions.addSocialDetailsError]: handleAddSocialDetailsError,

    [actions.getAllSocialDetailsRequest]: handleGetAllSocialDetailsRequest,
    [actions.getAllSocialDetailsSuccess]: handleGetAllSocialDetailsSuccess,
    [actions.getAllSocialDetailsError]: handleGetAllSocialDetailsError,

    [actions.updateSocialDetailsRequest]: handleUpdateSocialDetailsRequest,
    [actions.updateSocialDetailsSuccess]: handleUpdateSocialDetailsSuccess,
    [actions.updateSocialDetailsError]: handleUpdateSocialDetailsError,

    [actions.handleClearSocialDetails]: clearSocialDetails,


    //WORK EXPERIENCE DETAILS
    [actions.addWorkExperienceDetailsRequest]: handleAddWorkExperienceDetailsRequest,
    [actions.addWorkExperienceDetailsSuccess]: handleAddWorkExperienceDetailsSuccess,
    [actions.addWorkExperienceDetailsError]: handleAddWorkExperienceDetailsError,

    [actions.getWorkExperienceDetailsRequest]: handleGetWorkExperienceDetailsRequest,
    [actions.getWorkExperienceDetailsSuccess]: handleGetWorkExperienceDetailsSuccess,
    [actions.getWorkExperienceDetailsError]: handleGetWorkExperienceDetailsError,

    [actions.updateWorkExperienceDetailsRequest]: handleUpdateWorkExperienceDetailsRequest,
    [actions.updateWorkExperienceDetailsSuccess]: handleUpdateWorkExperienceDetailsSuccess,
    [actions.updateWorkExperienceDetailsError]: handleUpdateWorkExperienceDetailsError,

    [actions.handleClearWorkExperienceDetails]: clearWorkExperienceDetails,

    //REFERENCE DETAILS
    [actions.addReferenceDetailsRequest]: handleAddReferenceDetailsRequest,
    [actions.addReferenceDetailsSuccess]: handleAddReferenceDetailsSuccess,
    [actions.addReferenceDetailsError]: handleAddReferenceDetailsError,

    [actions.getAllReferenceDetailsRequest]: handleGetAllReferenceDetailsRequest,
    [actions.getAllReferenceDetailsSuccess]: handleGetAllReferenceDetailsSuccess,
    [actions.getAllReferenceDetailsError]: handleGetAllReferenceDetailsError,

    [actions.updateReferenceDetailsRequest]: handleUpdateReferenceDetailsRequest,
    [actions.updateReferenceDetailsSuccess]: handleUpdateReferenceDetailsSuccess,
    [actions.updateReferenceDetailsError]: handleUpdateReferenceDetailsError,

    [actions.handleClearReferenceDetails]: clearReferenceDetails,


    //DOCUMENT DETAILS
    [actions.addDocumentDetailsRequest]: handleAddDocumentDetailsRequest,
    [actions.addDocumentDetailsSuccess]: handleAddDocumentDetailsSuccess,
    [actions.addDocumentDetailsError]: handleAddDocumentDetailsError,

    [actions.getAllDocumentDetailsRequest]: handleGetAllDocumentDetailsRequest,
    [actions.getAllDocumentDetailsSuccess]: handleGetAllDocumentDetailsSuccess,
    [actions.getAllDocumentDetailsError]: handleGetAllDocumentDetailsError,

    [actions.updateDocumentDetailsRequest]: handleUpdateDocumentDetailsRequest,
    [actions.updateDocumentDetailsSuccess]: handleUpdateDocumentDetailsSuccess,
    [actions.updateDocumentDetailsError]: handleUpdateDocumentDetailsError,

    [actions.handleClearDocumentDetails]: clearDocumentDetails,

    [actions.getAllOnboardingDetailsRequest]: handleGetAllOnboardingDetailsRequest,
    [actions.getAllOnboardingDetailsSuccess]: handleGetAllOnboardingDetailsSuccess,
    [actions.getAllOnboardingDetailsError]: handleGetAllOnboardingDetailsError,

    [actions.getAllEmpDocsRequest]: handleGetAllEmpDocsRequest,
    [actions.getAllEmpDocsSuccess]: handleGetAllEmpDocsSuccess,
    [actions.getAllEmpDocsError]: handleGetAllEmpDocsError,

    [actions.handleClearOnboardingStore] :handleClearOnboardingStore
  },
  initialState,
);